import "../css/cate.css"
import "../css/wa.css"
import { MdOutlineArrowForwardIos, MdArrowForwardIos } from "react-icons/md"
import { RxDividerVertical } from "react-icons/rx"
import { IoTimeOutline, IoHeart } from "react-icons/io5"
import {
  FaCommentAlt,
  FaUser,
  FaRegCalendar,
  FaRegClock,
  FaRegHeart,
  FaRegCommentAlt,
  FaCheckCircle,
} from "react-icons/fa"
import { useEffect, useState } from "react"
import { publishPost } from "../api/postApi" // Assume you'll create this API function
import { useParams, useNavigate } from "react-router-dom"
import axios from "axios"
import SunEditor from "suneditor-react"
import "suneditor/dist/css/suneditor.min.css"
import CategoryHeadline from "../components/categoryHeadline"

function Category() {
  const { id } = useParams() // URL에서 id를 가져옴
  const navigate = useNavigate()
  const [ctData, setCtData] = useState("")
  const [categories, setCategories] = useState([])
  const [discData, setDiscData] = useState([])
  const [editorData, setEditorData] = useState("")
  const [title, setTitle] = useState("")
  const [articles, setArticles] = useState([])
  const [news, setNews] = useState([])
  const [hotArticles, setHotArticles] = useState([])
  const [qnas, setQnas] = useState([])
  const [hotQnas, setHotQnas] = useState([])

  const [expertArticle, setExpertArticle] = useState([])
  const [expertHot, setExpertHot] = useState([])
  const [expertList, setExpertList] = useState([])

  // Add activeTab state to manage tab switching
  const [activeTab, setActiveTab] = useState("1")

  // Pagination state
  const [currentPageE, setCurrentPageE] = useState(1)
  const [totalPagesE, setTotalPagesE] = useState(1)

  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [pageInputValue, setPageInputValue] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const [pageInputValueE, setPageInputValueE] = useState("")

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        let { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category/get`, {
          id,
        })
        data = data.results[0]
        setCtData(data)
      } catch (error) {
        alert("오류가 발생했습니다.")
      }
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category/dis/get`, { id })
      console.log("Response Data:", data.results)
      setDiscData(data.results)
    }

    const getArticles = async () => {
      setIsLoading(true)
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category/fetch_sp`, {
          id,
          page: currentPage,
        })
        setHotArticles(data.hot)
        setArticles(data.articles)
        setNews(data.hotNews)
        setTotalPages(data.pagination.totalPages)
      } catch (error) {
        console.error("Error fetching articles:", error)
      } finally {
        setIsLoading(false)
      }
    }

    const getCategories = async () => {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category/fetch`, {})
        setCategories(data.categories)
      } catch (error) {
        console.error("Error fetching categories:", error)
      }
    }

    const getQna = async () => {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/getqna`, { id })
        setQnas(data.qna)
        setHotQnas(data.hotQna)
      } catch (error) {
        console.error("Error fetching categories:", error)
      }
    }

    const getExpert = async () => {
      try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category/fetchexpert`, { id, page: currentPageE })
        setExpertArticle(data.articles)
        setExpertHot(data.hot)
        setExpertList(data.expertDetails)
        setTotalPagesE(data.pagination.totalPages)
        console.log(data.articles)
      } catch (error) {
        console.error("Error fetching categories:", error)
      }
    }

    getExpert()
    getQna()
    getArticles()
    getCategories()
    fetchCategoryData()
  }, [id, currentPage, currentPageE]) // Added currentPage as dependency

  // Function to fetch articles for a specific page
  const fetchArticlesByPage = async (page) => {
    if (page < 1 || page > totalPages) return

    setIsLoading(true)
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/category/fetch_articles_by_page`, {
        id,
        page,
      })
      setArticles(data.articles)
      setCurrentPage(data.pagination.currentPage)
    } catch (error) {
      console.error("Error fetching articles by page:", error)
    } finally {
      setIsLoading(false)
    }
  }

  // Handle page navigation
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  const goToPageE = (page) => {
    if (page >= 1 && page <= totalPagesE) {
      setCurrentPageE(page)
    }
  }

  // Handle manual page input
  const handlePageInputChange = (e) => {
    setPageInputValue(e.target.value)
  }

  const handlePageInputChangeE = (e) => {
    setPageInputValueE(e.target.value)
  }

  // Handle page input submission
  const handlePageInputSubmit = () => {
    const pageNumber = Number.parseInt(pageInputValue)
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      goToPage(pageNumber)
      setPageInputValue("")
    } else {
      alert(`페이지 번호는 1에서 ${totalPages} 사이여야 합니다.`)
    }
  }

  const handlePageInputSubmitE = () => {
    const pageNumber = Number.parseInt(pageInputValueE)
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPagesE) {
      goToPageE(pageNumber)
      setPageInputValueE("")
    } else {
      alert(`페이지 번호는 1에서 ${totalPagesE} 사이여야 합니다.`)
    }
  }

  const goToCategory = (code) => {
    navigate("/community/" + code)
  }

  // Replace DOM manipulation with state-based tab switching
  const selectScreen = (screenId) => {
    setActiveTab(screenId)
  }

  const handleEditorChange = (content) => {
    setEditorData(content)
  }

  const handlePublish = async () => {
    // Validation checks
    if (!title.trim()) {
      alert("제목을 입력해주세요.")
      return
    }
    if (!editorData.trim()) {
      alert("내용을 입력해주세요.")
      return
    }
    try {
      const postData = {
        title: title,
        content: editorData,
        category: id,
        header: "DIS",
        tags: [],
        copyProtection: false,
      }
      const response = await publishPost(postData)
      if (response && response.articleId) {
        // Redirect to the newly created post
        window.location.href = `/community/article/${response.articleId}`
      } else {
        alert("글 발행에 실패했습니다. 다시 시도해주세요.")
      }
    } catch (error) {
      console.error("Publication error:", error)

      // Handle 401 Unauthorized response
      if (error.response && error.response.status === 401) {
        alert("로그인이 필요합니다. 로그인 페이지로 이동합니다.")
        window.location.href = "/login"
      } else {
        alert("글 발행 중 오류가 발생했습니다.")
      }
    }
  }

  // Generate page numbers for pagination
  const renderPageNumbers = () => {
    const pageNumbers = []
    const maxVisiblePages = 5

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div key={i} className={`wa-page-number ${currentPage === i ? "active" : ""}`} onClick={() => goToPage(i)}>
          {i}
        </div>,
      )
    }

    return pageNumbers
  }

  const renderPageNumbersE = () => {
    const pageNumbers = []
    const maxVisiblePages = 5

    let startPage = Math.max(1, currentPageE - Math.floor(maxVisiblePages / 2))
    const endPage = Math.min(totalPagesE, startPage + maxVisiblePages - 1)

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div key={i} className={`wa-page-number ${currentPageE === i ? "active" : ""}`} onClick={() => goToPageE(i)}>
          {i}
        </div>,
      )
    }

    return pageNumbers
  }

  return (
    <>
      <div className="cte-main">
        <div className="cm-category-banner">
          <div className="category" onClick={() => goToCategory("")}>
            커뮤니티 홈
          </div>

          {categories.map((ct) => (
            <div
              key={ct.id}
              className={`category ${ct.id === id ? "selected" : ""}`}
              id={ct.id}
              onClick={() => (window.location.href = `/community/${ct.id}`)}
            >
              {ct.name}
            </div>
          ))}
        </div>

        <div className="cte-banner" style={{ backgroundColor: ctData.color }}>
          <div className="cte-banner-desc">
            <p className="title">{ctData.name}</p>
            <p>{ctData.desc}</p>
          </div>
          <div className="cte-banner-menu">
            {/* Use state-based active class instead of DOM manipulation */}
            <div className={`menu ${activeTab === "1" ? "selected" : ""}`} onClick={() => selectScreen("1")}>
              홈
            </div>
            <div className={`menu ${activeTab === "5" ? "selected" : ""}`} onClick={() => selectScreen("5")}>
              익스퍼트
            </div>
            <div className={`menu ${activeTab === "2" ? "selected" : ""}`} onClick={() => selectScreen("2")}>
              토론
            </div>
            <div className={`menu ${activeTab === "3" ? "selected" : ""}`} onClick={() => selectScreen("3")}>
              Q&A
            </div>
          </div>
        </div>
        <div className="cte-sc-container">
          {/* Use conditional rendering based on activeTab state instead of CSS classes */}
          <div
            className={`cte-sc ${activeTab === "1" ? "selected" : ""}`}
            id="sc-1"
            style={{ padding: 15, display: activeTab === "1" ? "flex" : "none" }}
          >
            <div className="cte-block flex-4">
              <div className="cte-headline-ct">
                <CategoryHeadline categoryId={id} />
              </div>
              <div className="cte-flex">
                <div className="wa-card">
                  <div className="wa-card-title">전체 글</div>
                  {isLoading ? (
                    <div className="loading-indicator">로딩 중...</div>
                  ) : (
                    articles.map((article) => (
                      <div
                        key={article.id}
                        className="cm-card-list-item"
                        onClick={() => (window.location.href = `/community/article/${article.id}`)}
                      >
                        {article.previewImage ? (
                          <div className="cm-card-list-item-thumb wa-thumb">
                            <img src={article.previewImage || "/placeholder.svg"} alt="" />
                          </div>
                        ) : null}
                        <div className="cm-card-list-item-content">
                          <div className="cm-card-list-item-title">
                            <span style={{ fontWeight: 600, color: article.headColor }}>[{article.headName}]</span>
                            {article.title}
                          </div>
                          <div className="cm-card-list-item-meta">
                            <IoTimeOutline />
                            <span className="meta-time">{article.date}</span>
                            <span className="meta-divider">·</span>
                            <span className="meta-likes">
                              <IoHeart />
                              {article.like}
                            </span>
                            <span className="meta-divider">·</span>
                            <span className="meta-comments">
                              <FaCommentAlt className="icon-smaller" />
                              {article.commentCount}
                            </span>
                            <span className="meta-divider">·</span>
                            <span className="meta-time">
                              <FaUser />
                              {article.username}
                              
                              {article.expert === '1' && <FaCheckCircle className='check' />}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                  <div className="wa-page">
                    {currentPage > 1 && (
                      <div className="wa-page-number prev" onClick={() => goToPage(currentPage - 1)}>
                        이전
                      </div>
                    )}

                    {renderPageNumbers()}

                    {currentPage < totalPages && (
                      <div className="wa-page-number next" onClick={() => goToPage(currentPage + 1)}>
                        다음
                      </div>
                    )}

                    <input
                      className="wa-page-number input"
                      type="number"
                      placeholder="이동할 페이지 번호"
                      value={pageInputValue}
                      onChange={handlePageInputChange}
                      min="1"
                      max={totalPages}
                    />
                    <button className="wa-page-number" onClick={handlePageInputSubmit}>
                      이동
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="cte-block flex-2" style={{ marginLeft: 15 }}>
              <div className="wa-card" style={{ marginLeft: 0 }}>
                <div className="wa-card-title">인기글</div>
                {hotArticles.map((article) => (
                  <div
                    key={article.id}
                    className="cm-card-list-item"
                    onClick={() => (window.location.href = `/community/article/${article.id}`)}
                  >
                    {article.previewImage ? (
                      <div className="cm-card-list-item-thumb wa-thumb">
                        <img src={article.previewImage || "/placeholder.svg"} alt="" />
                      </div>
                    ) : null}
                    <div className="cm-card-list-item-content">
                      <div className="cm-card-list-item-title">
                        <span style={{ fontWeight: 600, color: article.headColor }}>[{article.headName}]</span>
                        {article.title}
                      </div>
                      <div className="cm-card-list-item-meta">
                        <IoTimeOutline />
                        <span className="meta-time">{article.date}</span>
                        <span className="meta-divider">·</span>
                        <span className="meta-likes">
                          <IoHeart />
                          {article.like}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-comments">
                          <FaCommentAlt className="icon-smaller" />
                          {article.commentCount}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-time">
                          <FaUser />
                          {article.username}
                          {article.expert === '1' && <FaCheckCircle className='check' />}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="wa-card" style={{ marginLeft: 0 }}>
                <div className="wa-card-title">뉴스</div>
                {news.map((article) => (
                  <div
                    key={article.id}
                    className="cm-card-list-item"
                    onClick={() => (window.location.href = `/community/article/${article.id}`)}
                  >
                    {article.previewImage ? (
                      <div className="cm-card-list-item-thumb wa-thumb">
                        <img src={article.previewImage || "/placeholder.svg"} alt="" />
                      </div>
                    ) : null}
                    <div className="cm-card-list-item-content">
                      <div className="cm-card-list-item-title">{article.title}</div>
                      <div className="cm-card-list-item-meta">
                        <IoTimeOutline />
                        <span className="meta-time">{article.date}</span>
                        <span className="meta-divider">·</span>
                        <span className="meta-likes">
                          <IoHeart />
                          {article.like}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-comments">
                          <FaCommentAlt className="icon-smaller" />
                          {article.commentCount}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-time">
                          <FaUser />
                          {article.username}
                          {article.expert === '1' && <FaCheckCircle className='check' />}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="wa-card" style={{ marginLeft: 0 }}>
                <div className="wa-card-title">익스퍼트 인기글</div>
                {expertHot.map((article) => (
                  <div
                    key={article.id}
                    className="cm-card-list-item"
                    onClick={() => (window.location.href = `/community/article/${article.id}`)}
                  >
                    {article.previewImage ? (
                      <div className="cm-card-list-item-thumb wa-thumb">
                        <img src={article.previewImage || "/placeholder.svg"} alt="" />
                      </div>
                    ) : null}
                    <div className="cm-card-list-item-content">
                      <div className="cm-card-list-item-title">
                        <span style={{ fontWeight: 600, color: article.headColor }}>[{article.headName}]</span>
                        {article.title}
                      </div>
                      <div className="cm-card-list-item-meta">
                        <IoTimeOutline />
                        <span className="meta-time">{article.date}</span>
                        <span className="meta-divider">·</span>
                        <span className="meta-likes">
                          <IoHeart />
                          {article.like}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-comments">
                          <FaCommentAlt className="icon-smaller" />
                          {article.commentCount}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-time">
                          <FaUser />
                          {article.username}
                          {article.expert === '1' && <FaCheckCircle className='check' />}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Discussion tab */}
          <div
            className={`cte-sc ${activeTab === "2" ? "selected" : ""}`}
            id="sc-2"
            style={{ paddingBottom: 0, display: activeTab === "2" ? "flex" : "none" }}
          >
            <div className="cte-editor" style={{ display: "block" }}>
              <SunEditor
                mode="inline"
                onChange={handleEditorChange}
                setContents={editorData}
                placeholder="토론을 시작해보세요..."
                lang="ko"
                setOptions={{
                  maxHeight: "550px",
                  placeholder: "여기에 내용을 입력해주세요...",
                  buttonList: [
                    ["undo", "redo"],
                    ["formatBlock"],
                    ["bold", "italic", "underline", "strike", "fontColor", "hiliteColor"],
                    ["align", "horizontalRule"],
                    ["outdent", "indent"],
                    ["table", "link", "image"],
                  ],
                  font: ["Wanted Sans", "Arial", "Comic Sans MS", "Courier New", "Georgia", "Tahoma", "Verdana"],
                  fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                  defaultStyle: "font-size: 16px; font-family: Arial, sans-serif;",
                }}
              />
              <input placeholder="제목을 입력하세요." value={title} onChange={(e) => setTitle(e.target.value)}></input>
              <div style={{ display: "flex" }}>
                <button onClick={handlePublish} className="ct-btn">
                  게시
                </button>
              </div>
            </div>

            <div className="cte-mar">
              {discData.map((post) => (
                <div
                  className="cte-ds-post"
                  key={post.id}
                  onClick={() => (window.location.href = `/community/article/${post.id}`)}
                >
                  <div className="cte-ds-post-ctarea">
                    <div className="at-comment-ct-header">
                      <div className="at-comment-ct-profile wa-profile">
                        <img src={post.writerData.profile || "/placeholder.svg"} alt="Profile" />
                      </div>
                      <div className="at-comment-ct-name">{post.writerData.username}</div>
                      <div className="at-comment-ct-info" style={{ marginLeft: "5px" }}>
                        <FaRegClock /> {post.date}
                      </div>
                    </div>
                    <div className="cte-ds-post-title">{post.title}</div>
                    <div className="cte-ds-post-content" dangerouslySetInnerHTML={{ __html: post.article }}></div>
                    <div className="cte-ds-cmcount">
                      {post.commentCount}개의 의견
                      <MdOutlineArrowForwardIos />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Q&A tab */}
          <div
            className={`cte-sc ${activeTab === "3" ? "selected" : ""}`}
            id="sc-3"
            style={{ display: activeTab === "3" ? "flex" : "none" }}
          >
            <div className="cte-editor" style={{ display: "block" }}>
              <SunEditor
                mode="inline"
                onChange={handleEditorChange}
                setContents={editorData}
                placeholder="질문해보세요..."
                lang="ko"
                setOptions={{
                  maxHeight: "550px",
                  placeholder: "여기에 내용을 입력해주세요...",
                  buttonList: [
                    ["undo", "redo"],
                    ["formatBlock"],
                    ["bold", "italic", "underline", "strike", "fontColor", "hiliteColor"],
                    ["align", "horizontalRule"],
                    ["outdent", "indent"],
                    ["table", "link", "image"],
                  ],
                  font: ["Wanted Sans", "Arial", "Comic Sans MS", "Courier New", "Georgia", "Tahoma", "Verdana"],
                  fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                  defaultStyle: "font-size: 16px; font-family: Arial, sans-serif;",
                }}
              />
              <input placeholder="제목을 입력하세요." value={title} onChange={(e) => setTitle(e.target.value)}></input>
              <div style={{ display: "flex" }}>
                <button onClick={handlePublish} className="ct-btn">
                  게시
                </button>
              </div>
            </div>

            <div className="cte-flex" style={{ padding: 15, paddingTop: 0, width: "100%" }}>
              <div className="wa-card">
                <div className="wa-card-title">최신 Q&A</div>
                {qnas.map((article) => (
                  <div
                    className="cm-card-list-item"
                    key={article.id}
                    onClick={() => (window.location.href = `/community/article/${article.id}`)}
                  >
                    {article.previewImage ? (
                      <div className="cm-card-list-item-thumb wa-thumb">
                        <img src={article.previewImage || "/placeholder.svg"} alt="Preview" />
                      </div>
                    ) : null}
                    <div className="cm-card-list-item-content">
                      <div className="cm-card-list-item-title">{article.title}</div>
                      <div className="cm-card-list-item-meta">
                        \`\`\`\`\`\`
                        <IoTimeOutline />
                        <span className="meta-time">{article.date}</span>
                        <span className="meta-divider">·</span>
                        <span className="meta-likes">
                          <IoHeart />
                          {article.like}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-comments">
                          <FaCommentAlt className="icon-smaller" />
                          {article.commentCount}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-time">
                          <FaUser />
                          {article.username}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="wa-card">
                <div className="wa-card-title">인기 Q&A</div>
                {hotQnas.map((article) => (
                  <div
                    className="cm-card-list-item"
                    key={article.id}
                    onClick={() => (window.location.href = `/community/article/${article.id}`)}
                  >
                    {article.previewImage ? (
                      <div className="cm-card-list-item-thumb wa-thumb">
                        <img src={article.previewImage || "/placeholder.svg"} alt="Preview" />
                      </div>
                    ) : null}
                    <div className="cm-card-list-item-content">
                      <div className="cm-card-list-item-title">{article.title}</div>
                      <div className="cm-card-list-item-meta">
                        <IoTimeOutline />
                        <span className="meta-time">{article.date}</span>
                        <span className="meta-divider">·</span>
                        <span className="meta-likes">
                          <IoHeart />
                          {article.like}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-comments">
                          <FaCommentAlt className="icon-smaller" />
                          {article.commentCount}
                        </span>
                        <span className="meta-divider">·</span>
                        <span className="meta-time">
                          <FaUser />
                          {article.username}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* News tab */}
          <div
            className={`cte-sc ${activeTab === "4" ? "selected" : ""}`}
            id="sc-4"
            style={{ padding: 15, display: activeTab === "4" ? "flex" : "none" }}
          >
            <div className="wa-card">
              <div className="wa-card-title">뉴스 속보</div>
            </div>
            <div className="wa-card">
              <div className="wa-card-title">인기 Q&A</div>
            </div>
          </div>

          {/* Expert tab */}
          <div
            className={`cte-sc ${activeTab === "5" ? "selected" : ""}`}
            id="sc-5"
            style={{ padding: 15, display: activeTab === "5" ? "block" : "none" }}
          >
            <div className="cte-flex" style={{ marginTop: 0 }}>
              <div className="cte-block flex-4">
                <div className="article-l" style={{ padding: 25 }}>
                  <span className="title">
                    <FaCheckCircle />
                    익스퍼트 전용 게시판
                  </span>
                  <span>익스퍼트란? 전문가로 인증된 유저입니다.</span>

                  <div className="cte-gointo">
                    <span onClick={() => (window.location.href = `/expert`)}>
                      자세히 알아보기 <MdArrowForwardIos />
                    </span>
                    <RxDividerVertical />
                    <span onClick={() => (window.location.href = `/form?type=expert`)}>
                      익스퍼트 신청하기 <MdArrowForwardIos />
                    </span>
                  </div>
                </div>
                {expertArticle.map((article) => (
                  <div
                    className="article-l"
                    onClick={() => (window.location.href = `/community/article/${article.id}`)}
                  >
                    <div className="article-l-main">
                      {article.previewImage ? (
                        <div className="article-l-preview">
                          <img src={article.previewImage || "/placeholder.svg"} alt="Preview" />
                        </div>
                      ) : null}
                      <div className="article-l-infoarea">
                        <div className="article-l-title">{article.title}</div>
                        <div className="article-l-desc" style={{
                            whiteSpace: 'nowrap', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis', 
                            width: '100%', 
                            display: 'block'
                          }}>{article.previewArticle}</div>
                      </div>
                    </div>
                    <div className="article-l-bottom">
                      <div className="article-l-profile">
                        <div className="article-l-profile-exp">{article.expertCategory}</div>
                        <div className="article-l-profile-image wa-profile">
                          <img src={article.profile || "/placeholder.svg"}></img>
                        </div>
                        <div style={{ display: "block" }}>
                          <div className="article-l-name">{article.username}</div>
                          <div className="article-l-desc">
                            {article.organ} • {article.term}년차
                          </div>
                        </div>
                      </div>
                      <div className="article-l-info">
                        <div className="article-l-desc">
                          <FaRegCalendar /> {article.date} <FaRegCommentAlt />
                          {article.commentCount} <FaRegHeart /> {article.like}
                        </div>
                        <div className="article-l-go">
                          읽기 <MdOutlineArrowForwardIos />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="wa-page">
                  {currentPageE > 1 && (
                    <div className="wa-page-number prev" onClick={() => goToPageE(currentPageE - 1)}>
                      이전
                    </div>
                  )}

                  {renderPageNumbersE()}

                  {currentPageE < totalPagesE && (
                    <div className="wa-page-number next" onClick={() => goToPageE(currentPageE + 1)}>
                      다음
                    </div>
                  )}

                  <input
                    className="wa-page-number input"
                    type="number"
                    placeholder="이동할 페이지 번호"
                    value={pageInputValueE}
                    onChange={handlePageInputChangeE}
                    min="1"
                    max={totalPagesE}
                  />
                  <button className="wa-page-number" onClick={handlePageInputSubmitE}>
                    이동
                  </button>
                </div>
              </div>
              <div className="cte-block flex-2">
                <div className="wa-card">
                  <div className="wa-card-title">익스퍼트 인기글</div>
                  {expertHot.map((article) => (
                    <div
                      key={article.id}
                      className="cm-card-list-item"
                      onClick={() => (window.location.href = `/community/article/${article.id}`)}
                    >
                      {article.previewImage ? (
                        <div className="cm-card-list-item-thumb wa-thumb">
                          <img src={article.previewImage || "/placeholder.svg"} alt="" />
                        </div>
                      ) : null}
                      <div className="cm-card-list-item-content">
                        <div className="cm-card-list-item-title">
                          <span style={{ fontWeight: 600, color: article.headColor }}>[{article.headName}]</span>
                          {article.title}
                        </div>
                        <div className="cm-card-list-item-meta">
                          <IoTimeOutline />
                          <span className="meta-time">{article.date}</span>
                          <span className="meta-divider">·</span>
                          <span className="meta-likes">
                            <IoHeart />
                            {article.like}
                          </span>
                          <span className="meta-divider">·</span>
                          <span className="meta-comments">
                            <FaCommentAlt className="icon-smaller" />
                            {article.commentCount}
                          </span>
                          <span className="meta-divider">·</span>
                          <span className="meta-time">
                            <FaUser />
                            {article.username}
                            {article.expert === '1' && <FaCheckCircle className='check' />}

                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="wa-card">
                  <div className="wa-card-title">이 카테고리에서 활동하는 익스퍼트</div>
                  {expertList.map((user) => (
                    <div className="cte-expert-user" onClick={() => (window.location.href = `/profile/${user.id}`)}>
                      <div className="image wa-profile"><img src={user.profile}></img></div>
                      <div className="expert-info">{user.expertCategory}</div>
                      <div className="cte-block">
                        <div className="name">{user.username}</div>
                        <div 
                          className="desc" 
                          style={{
                            whiteSpace: 'nowrap', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis', 
                            width: '100%', 
                            display: 'block'
                          }}
                        >
                          {user.desc}
                        </div>

                      </div>
                    </div>
                  ))}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Category

